import { render, staticRenderFns } from "./ZigBeeSwitch.vue?vue&type=template&id=395ecdfc&scoped=true&"
import script from "./ZigBeeSwitch.vue?vue&type=script&lang=js&"
export * from "./ZigBeeSwitch.vue?vue&type=script&lang=js&"
import style0 from "./ZigBeeSwitch.vue?vue&type=style&index=0&id=395ecdfc&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "395ecdfc",
  null
  
)

export default component.exports